<template>
  <a-modal
    :visible="visible"
    title="分析结果"
    width="40%"
    centered
    :destroyOnClose="true"
    :maskClosable="false"
    :footer="null"
    @cancel="handleCancel"
    :zIndex="10"
  >
    <div class="results-body">
      <a-form ref="resultsFormRef" :model="formData" layout="horizontal">
        <!-- <a-form-item label="AI算法分析结果" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-textarea
              v-model:value="formData.analysisResult"
              placeholder="请输入AI算法分析结果"
              :rows="3"
            />
            <a-button
              type="primary"
              :loading="algorithmAnalysisLoading"
              @click="handleAlgorithmAnalysis"
              v-if="!record?.analysis_result"
            >
              算法识别
            </a-button>
          </div>
        </a-form-item> -->

        <a-form-item label="AI大模型识别结果" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-textarea
              v-model:value="formData.largeModelAnalysisResult"
              placeholder="请输入大模型识别结果"
              :rows="3"
              style="flex: 1;"
            />
            <a-tooltip title="隐患识别">
                <SvgIcon name="AIshibie" class="analysis-position" @click="openAiAnalysis('largeModelAnalysisResult')"/>
            </a-tooltip>
            <!-- <a-button type="primary">
              模型识别
            </a-button> -->
          </div>
        </a-form-item>

        <a-form-item label="AI大模型识别条例" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <div style="display: flex; align-items: center; gap: 8px;">
            <div style="flex: 1; min-width: 0;">
              <a-spin :spinning="regulationLoading" tip="加载中...">
                <a-textarea
                  v-model:value="formData.regulationDetails"
                  placeholder="请输入模型识别条例"
                  :rows="3"
                  style="width: 100%;"
                  :disabled="regulationLoading"
                />
              </a-spin>
            </div>
            <a-tooltip title="条例识别">
                <SvgIcon name="AIshibie" class="analysis-position" @click="openAiAnalysis('regulationDetails')"/>
            </a-tooltip>
            <!-- <a-button type="primary" @click="openAiAnalysis('regulationDetails')">
              识别条例
            </a-button> -->
          </div>
        </a-form-item>
      </a-form>

      <div class="results-actions">
        <a-button type="primary" :loading="saveLoading" @click="handleSave">保存</a-button>
        <a-button @click="handleCancel">取消</a-button>
      </div>
    </div>

    <!-- 专题应用选择弹窗（AI识别/条例识别） -->
    <a-modal
      v-model:visible="aiResultVisible"
      :title="aiTitle"
      width="1200px"
      :mask-closable="false"
      centered
      @cancel="handleCloseAiResult"
      :zIndex="20"
    >
      <div class="special-app-content">
        <a-spin :spinning="aiResultLoading" tip="加载中...">
          <template v-for="categoryItem in categoryList" :key="categoryItem.code || categoryItem.id">
            <div v-if="getAppsByCategory(categoryItem.code).length > 0" class="category-section">
              <div class="category-title">
                <div class="title-bar"></div>
                <span class="title-text">
                  {{ categoryItem.fullPathName || categoryItem.name }}
                </span>
              </div>
              <div class="app-grid">
                <div
                  v-for="app in getAppsByCategory(categoryItem.code)"
                  :key="app.id"
                  class="app-card"
                  :class="{ selected: isSelected(app.id) }"
                  :style="{ background: getCardBackground(app.colorTheme) }"
                  @click="handleCardClick(app)"
                >
                  <div class="app-icon">
                    <a-image
                      v-if="app.iconPath"
                      :src="getIconUrl(app.iconPath)"
                      :preview="false"
                      fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ccc'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z'/%3E%3C/svg%3E"
                    />
                    <SettingOutlined v-else class="app-icon-placeholder" />
                  </div>
                  <div class="app-name">{{ app.appName }}</div>
                </div>
              </div>
            </div>
          </template>
          <a-empty v-if="!aiResultLoading && appList.length === 0" description="暂无专题应用数据" />
        </a-spin>
      </div>
      <template #footer>
        <a-button @click="handleCloseAiResult">关闭</a-button>
        <a-button type="primary" :loading="submitAiLoading" @click="toggleSelection" :disabled="!aiResultForm.typeId">识别</a-button>
      </template>
    </a-modal>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, reactive, watch, defineProps, defineEmits } from 'vue'
import { message } from 'ant-design-vue'
import { SettingOutlined } from '@ant-design/icons-vue'
import {
  getAlgoAnalysisResult,
  updateFileAnalysisResult,
  getFileUrlByObjectKeyLong,
} from '/@/api/insp/insp-media'
import { getAllSpecialData, listAllSpecialAppCategory } from '/@/api/insp/insp-regulations'
import { getAcquisitionRegulations, getAlarmModelAnalysis } from '/@/api/insp/insp-alarm'
import { getAllAlgList } from '/@/api/insp-algorithm'

// Props
const props = defineProps<{
  record: any
  visible: boolean
}>()

const emit = defineEmits<{
  'update:visible': [value: boolean]
  'saved': []
}>()

// 表单数据
const formData = reactive({
  analysisResult: '',
  largeModelAnalysisResult: '',
  regulationDetails: '',
})

// 加载状态
const saveLoading = ref(false)
const lastSelectedSpecialApp = ref<{ type: string; typeName: string } | null>(null)
const regulationLoading = ref(false)
const aiResultLoading = ref(false)
const submitAiLoading = ref(false)

// 专题应用相关
const aiResultVisible = ref(false)
const aiTitle = ref('')
const categoryList = ref<any[]>([])
const appList = ref<any[]>([])
const aiResultType = ref('')
const aiResultForm = reactive({
  fileId: '',
  typeId: '',
  typeName: '',
  analysisResult: '',
  type: '',
})
const currentAiTargetField = ref('')
const currentAiResultRow = ref<any>(null)

// 算法列表相关
const algorithmDataList = ref<any[]>([])
const formAlgoAnalysisData = ref({
  algorithmId: null,
  confidence: 0.5,
  enableLargeModel: 0,
})
const algoMediaAnalysisVisible = ref(false)
const submitAlgoAnalysisLoading = ref(false)
const isFromPreview = ref(false)

// 图标缓存
const iconUrlCache = reactive<Record<string, string>>({})
const fetchingIconUrls = new Set<string>()

const themeColorMap: Record<string, string> = {
  green: '#52c41a',
  purple: '#722ed1',
  orange: '#fa8c16',
  blue: '#1890ff',
  pink: '#eb2f96',
  violet: '#9254de',
}

// 监听 record 变化，初始化表单数据
watch(
  () => props.record,
  (newRecord) => {
    if (newRecord) {
      formData.analysisResult = newRecord.analysis_result || ''
      formData.largeModelAnalysisResult = newRecord.large_model_analysis_result || ''
      formData.regulationDetails = newRecord.regulation_details || ''
    }
  },
  { immediate: true }
)

// 监听 visible 变化，加载算法列表
watch(
  () => props.visible,
  (val) => {
    if (val) {
      loadAlgorithmList()
    }
  }
)

// 关闭主弹窗
const handleCancel = () => {
  formData.analysisResult = ''
  formData.largeModelAnalysisResult = ''
  formData.regulationDetails = ''
  regulationLoading.value = false
  emit('update:visible', false)
}

// 保存分析结果
const handleSave = async () => {
  if (!props.record) {
    message.error('文件信息丢失')
    return
  }
  saveLoading.value = true
  try {
    const toStr = (val: any): string => {
      if (val === null || val === undefined) return ''
      if (Array.isArray(val)) return val.join('\n')
      return String(val)
    }
    const params = {
      fileId: props.record.file_id,
      analysisResult: formData.analysisResult,
      largeModelAnalysisResult: toStr(formData.largeModelAnalysisResult),
      regulationDetails: formData.regulationDetails,
    }
    const res = await updateFileAnalysisResult(params)
    if (res.code === 0) {
      message.success('保存成功')
      emit('saved') // 通知父组件刷新数据
      handleCancel() // 关闭弹窗
    } else {
      message.error(res.message || '保存失败')
    }
  } catch (error) {
    message.error('保存失败，请重试')
  } finally {
    saveLoading.value = false
  }
}

// 算法识别（AI算法分析结果）
const handleAlgorithmAnalysis = async () => {
  if (!props.record) {
    message.error('文件信息丢失')
    return
  }
  // 检查是否已有分析结果
  const hasAnalysisResult = (() => {
    const result = props.record.analysis_result
    if (!result) return false
    if (typeof result === 'string') {
      return result !== '' && result !== '{}'
    }
    if (Array.isArray(result)) {
      return result.length > 0
    }
    if (typeof result === 'object') {
      return Object.keys(result).length > 0
    }
    return false
  })()

  if (hasAnalysisResult) {
    // 已有分析结果，直接填充到表单
    let formattedResult = ''
    const rawResult = props.record.analysis_result
    if (typeof rawResult === 'string') {
      try {
        const parsed = JSON.parse(rawResult)
        if (Array.isArray(parsed)) {
          formattedResult = parsed.map((item) => `${item.name || item.type}: ${item.count || 0}`).join('\n')
        } else {
          formattedResult = rawResult
        }
      } catch {
        formattedResult = rawResult
      }
    } else if (Array.isArray(rawResult)) {
      formattedResult = rawResult.map((item) => `${item.name || item.type}: ${item.count || 0}`).join('\n')
    } else {
      formattedResult = JSON.stringify(rawResult, null, 2)
    }
    formData.analysisResult = formattedResult
    return
  }

  // 无分析结果，弹出算法选择弹窗
  isFromPreview.value = false
  submitAlgoAnalysisFileId.value = props.record.file_id
  formAlgoAnalysisData.value = {
    algorithmId: null,
    confidence: 0.5,
    enableLargeModel: 0,
  }
  algoMediaAnalysisVisible.value = true
}

// 算法识别相关状态
const submitAlgoAnalysisFileId = ref('')
const handleCloseAlgoMediaAnalysis = () => {
  algoMediaAnalysisVisible.value = false
  submitAlgoAnalysisLoading.value = false
  formAlgoAnalysisData.value.algorithmId = null
  formAlgoAnalysisData.value.confidence = 0.5
  formAlgoAnalysisData.value.enableLargeModel = 0
}

const toggleAlgoAnalysis = async () => {
  if (!submitAlgoAnalysisFileId.value) {
    message.error('文件ID丢失')
    return
  }
  submitAlgoAnalysisLoading.value = true
  try {
    const res = await getAlgoAnalysisResult(
      submitAlgoAnalysisFileId.value,
      formAlgoAnalysisData.value.confidence,
      formAlgoAnalysisData.value.algorithmId,
      formAlgoAnalysisData.value.enableLargeModel
    )
    if (res.code === 0) {
      message.success('分析成功')
      if (res.data && res.data.analysisUrl) {
        let displayText = ''
        if (typeof res.data.analysisResult === 'string') {
          displayText = res.data.analysisResult
        } else if (Array.isArray(res.data.analysisResult)) {
          displayText = res.data.analysisResult
            .map((item) => `${item.name || item.type}: ${item.count || 0}`)
            .join('\n')
        } else if (typeof res.data.analysisResult === 'object') {
          displayText = Object.entries(res.data.analysisResult)
            .map(([k, v]) => `${k}: ${v}`)
            .join('\n')
        } else {
          displayText = String(res.data.analysisResult)
        }
        formData.analysisResult = displayText
        // 不再直接修改 props.record，由父组件刷新时更新
      }
      algoMediaAnalysisVisible.value = false
    } else {
      message.error(res.message || '分析失败')
    }
  } catch (error) {
    message.error('分析失败')
  } finally {
    submitAlgoAnalysisLoading.value = false
  }
}

// 加载算法列表
const loadAlgorithmList = async () => {
  try {
    const res = await getAllAlgList({})
    if (res && res.code === 200) {
      algorithmDataList.value = res.data || []
    }
  } catch (error) {
    console.error('加载算法列表失败', error)
  }
}

// ========== AI识别 / 条例识别 相关方法 ==========
const openAiAnalysis = async (field: 'largeModelAnalysisResult' | 'regulationDetails') => {
  if (!props.record) {
    message.warning('未找到媒体文件信息')
    return
  }

  // ===== 条例识别：优先复用已选择的专题 =====
  if (field === 'regulationDetails') {
    if (lastSelectedSpecialApp.value && formData.largeModelAnalysisResult) {
      regulationLoading.value = true
      try {
        const formDataReq = new FormData()
        formDataReq.append('portion', lastSelectedSpecialApp.value.typeName)
        formDataReq.append('type', lastSelectedSpecialApp.value.type)
        formDataReq.append('fileId', props.record.file_id)
        const res = await getAlarmModelAnalysis(formDataReq)
        const content = res.data?.hiddenDanger && res.data.hiddenDanger.length > 0
          ? res.data.hiddenDanger.join('\n')
          : ''
        formData.regulationDetails = content
        if (content) {
          message.success('条例识别成功')
        } else {
          message.info('未识别到相关条例')
        }
      } catch (error) {
        console.error('条例识别失败:', error)
        message.error('条例识别失败')
      } finally {
        regulationLoading.value = false
      }
      return
    }
  }

  // ===== 没有复用条件，弹出专题选择弹窗 =====
  currentAiTargetField.value = field
  currentAiResultRow.value = props.record
  aiTitle.value = field === 'largeModelAnalysisResult' ? 'AI识别' : '条例识别'
  await getCategoryList()
  await getAppList()
  aiResultVisible.value = true
}

const getCategoryList = async () => {
  try {
    const res = await listAllSpecialAppCategory(1)
    if (res?.code === 0) {
      const list = Array.isArray(res.data) ? res.data : []
      categoryList.value = buildCategoryFullPath(list).sort(compareCategory)
    } else {
      categoryList.value = []
    }
  } catch (error) {
    console.error('获取分类列表失败', error)
    categoryList.value = []
  }
}

const getAppList = async () => {
  aiResultLoading.value = true
  try {
    const response = await getAllSpecialData()
    if (response?.code === 0) {
      appList.value = Array.isArray(response.data) ? response.data : []
      appList.value.forEach((app) => {
        if (app.iconPath) loadIconUrl(app.iconPath)
      })
    } else {
      appList.value = []
      if (response?.msg) message.error(response.msg)
    }
  } catch (error) {
    console.error('查询专题应用列表失败:', error)
    message.error(error.message || '查询失败')
    appList.value = []
  } finally {
    aiResultLoading.value = false
  }
}

const getIconUrl = (objectKey: string) => {
  if (!objectKey) return ''
  if (/^https?:\/\//i.test(objectKey)) return objectKey
  return iconUrlCache[objectKey] || ''
}

const loadIconUrl = (objectKey: string) => {
  if (!objectKey) return
  if (/^https?:\/\//i.test(objectKey)) {
    iconUrlCache[objectKey] = objectKey
    return
  }
  if (iconUrlCache[objectKey] || fetchingIconUrls.has(objectKey)) return
  fetchingIconUrls.add(objectKey)
  getFileUrlByObjectKeyLong(objectKey)
    .then((res) => {
      if (res?.code === 0 && res.data) {
        iconUrlCache[objectKey] = res.data.toString()
      }
    })
    .catch(() => {
      iconUrlCache[objectKey] = objectKey
    })
    .finally(() => {
      fetchingIconUrls.delete(objectKey)
    })
}

const getCategoryTimestamp = (node: any) => {
  if (!node) return 0
  const value = node.createTime || node.createTimeStr || node.createTimeMillis
  if (!value) return 0
  if (typeof value === 'number') return value
  const time = new Date(value).getTime()
  return isNaN(time) ? 0 : time
}

const compareCategory = (a: any, b: any) => {
  return getCategoryTimestamp(b) - getCategoryTimestamp(a)
}

const buildCategoryFullPath = (list: any[]) => {
  if (!Array.isArray(list)) return []
  const map: Record<string, any> = {}
  list.forEach((item) => {
    if (item.id) map[item.id] = item
  })
  const getPathNames = (item: any) => {
    const names: string[] = []
    let current = item
    const safeGuard = new Set()
    while (current && current.id && !safeGuard.has(current.id)) {
      safeGuard.add(current.id)
      names.unshift(current.name)
      if (!current.parentId) break
      current = map[current.parentId]
    }
    return names.join(' / ')
  }
  return list.map((item) => ({
    ...item,
    fullPathName: getPathNames(item),
  }))
}

const getAppsByCategory = (category: string) => {
  return appList.value.filter((app) => app.category === category)
}

const isSelected = (id: string) => {
  return aiResultForm.typeId === id
}

const handleCardClick = (app: any) => {
  if (!currentAiResultRow.value) return
  aiResultForm.fileId = currentAiResultRow.value.file_id
  aiResultForm.typeId = app.id
  aiResultForm.typeName = app.appName
  aiResultForm.type = app.type
  if (aiResultType.value === 'regulation') {
    aiResultForm.analysisResult = currentAiResultRow.value.large_model_analysis_result || ''
  }
}

const getCardBackground = (colorTheme: string) => {
  if (!colorTheme) {
    return 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)'
  }
  let color = themeColorMap[colorTheme] || colorTheme
  if (color.startsWith('rgba')) {
    const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
    if (rgbaMatch) {
      const r = parseInt(rgbaMatch[1])
      const g = parseInt(rgbaMatch[2])
      const b = parseInt(rgbaMatch[3])
      color = `rgb(${r}, ${g}, ${b})`
    }
  }
  if (color.startsWith('#') || color.startsWith('rgb')) {
    let r: number, g: number, b: number
    if (color.startsWith('#')) {
      const hex = color.replace('#', '')
      r = parseInt(hex.substring(0, 2), 16)
      g = parseInt(hex.substring(2, 4), 16)
      b = parseInt(hex.substring(4, 6), 16)
    } else {
      const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
      if (rgbMatch) {
        r = parseInt(rgbMatch[1])
        g = parseInt(rgbMatch[2])
        b = parseInt(rgbMatch[3])
      } else {
        return `linear-gradient(135deg, ${color} 0%, ${color} 100%)`
      }
    }
    const darkerR = Math.max(0, Math.floor(r * 0.7))
    const darkerG = Math.max(0, Math.floor(g * 0.7))
    const darkerB = Math.max(0, Math.floor(b * 0.7))
    return `linear-gradient(135deg, ${color} 0%, rgb(${darkerR}, ${darkerG}, ${darkerB}) 100%)`
  }
  return color
}

const handleClearResult = () => {
  aiResultType.value = ''
  aiResultForm.fileId = ''
  aiResultForm.typeId = ''
  aiResultForm.typeName = ''
  aiResultForm.type = ''
  aiResultForm.analysisResult = ''
}

const handleCloseAiResult = () => {
  aiResultVisible.value = false
  handleClearResult()
}

const toggleSelection = async () => {
  if (!aiResultForm.typeId) {
    message.warning('请选择一个专题应用')
    return
  }
  submitAiLoading.value = true
  try {
    const fileId = aiResultForm.fileId
    if (!fileId) {
      throw new Error('文件ID丢失')
    }

    let content = ''
    if (currentAiTargetField.value === 'regulationDetails') {
      // 条例识别逻辑保持不变
      const toStr = (val: any): string => {
        if (val === null || val === undefined) return ''
        if (Array.isArray(val)) return val.join('\n')
        return String(val)
      }
      const hiddenDangerValue = aiResultForm.analysisResult || formData.largeModelAnalysisResult || ''
      const res = await getAcquisitionRegulations({
        type: aiResultForm.type,
        portion: aiResultForm.typeName,
        hiddenDanger: toStr(hiddenDangerValue),
      })
      content = res.data && res.data.length > 0
        ? res.data.map((el: any) => `${el.name}：${el.specifications.join('\n')}`).join('\n\n')
        : ''
    } else {
      // ===== AI大模型识别结果：保存专题信息供条例复用 =====
      lastSelectedSpecialApp.value = {
        type: aiResultForm.type,
        typeName: aiResultForm.typeName
      }

      const formDataReq = new FormData()
      formDataReq.append('portion', aiResultForm.typeName)
      formDataReq.append('type', aiResultForm.type)
      formDataReq.append('fileId', fileId)
      const res = await getAlarmModelAnalysis(formDataReq)
      content = res.data?.hiddenDanger && res.data.hiddenDanger.length > 0
        ? res.data.hiddenDanger.join('\n')
        : ''
    }

    if (currentAiTargetField.value === 'largeModelAnalysisResult') {
      formData.largeModelAnalysisResult = content
    } else if (currentAiTargetField.value === 'regulationDetails') {
      formData.regulationDetails = content
    }

    handleCloseAiResult()
  } catch (error) {
    console.error('识别失败:', error)
    message.error('识别失败')
  } finally {
    submitAiLoading.value = false
  }
}
</script>

<style lang="scss" scoped>
/* 样式保持不变，与之前相同 */
.results-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px 16px 16px 16px;

  .results-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }
}

.special-app-content {
  margin-top: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.category-section {
  margin-bottom: 40px;
}

.category-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .title-bar {
    width: 4px;
    height: 20px;
    background: #1890ff;
    margin-right: 12px;
    border-radius: 2px;
  }

  .title-text {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }
}

.app-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 20px;
}

.app-card {
  position: relative;
  height: 120px;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
    opacity: 0.3;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }

  &.selected {
    border: 2px solid #ff4d4f !important;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
    transform: scale(0.98);
  }

  .app-icon {
    position: relative;
    z-index: 2;
    font-size: 32px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
  }

  .app-name {
    position: relative;
    z-index: 2;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    flex: 1;
  }

  .app-count {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
    font-size: 14px;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 500;
  }
}

.app-icon-placeholder {
  font-size: 32px;
  color: #ffffff;
}

:deep(.analysis-position){
    font-size: 30px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4098eb;

    &:hover {
        color: #1890ff;
        transform: scale(1.1);
    }
}
</style>
